<template>
  <div>
    <base-box @getList="getList" :total="total" :loading="loading" trackCode='tradeListReceipt-1'>
      <template v-slot:mainTable="{height}">
        <el-table
          border
          row-class-name="table-row"
          header-row-class-name="table-header-cell"
          :data="list"
          v-loading="loading"
          :height="height"
          :key="height"
        >
          <el-table-column label="账单日期" prop="countingDate" min-width="120">
            <template slot-scope="{row}">
              <div>{{row.countingDate | formatTime('yyyy-MM-dd')}}</div>
            </template>
          </el-table-column>
          <el-table-column label="主体编号" prop="merchantNo" min-width="120" />
          <el-table-column label="对账主体名称" prop="merchantName" min-width="120" />
          <el-table-column label="未匹配数(元)" prop="unmatchedAmount" min-width="80" align="center">
            <template slot-scope="{row}">
              {{row.unmatchedAmount | toFenThousandsAndFloat}}
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统交易总金额(元)</div>
              <div>渠道交易总金额(元)</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finAmount | toFenThousandsAndFloat}}</div>
              <div>{{row.thirdAmount | toFenThousandsAndFloat}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统交易总笔数</div>
              <div>渠道交易总笔数</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finCount || '0'}}</div>
              <div>{{row.thirdCount || '0'}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统收款总笔数</div>
              <div>渠道收款总笔数</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finReceiptCount || '0'}}</div>
              <div>{{row.thirdReceiptCount || '0'}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统退款总笔数</div>
              <div>渠道退款总笔数</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finRefundCount || '0'}}</div>
              <div>{{row.thirdRefundCount || '0'}}</div>
            </template>
          </el-table-column>

          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统手续费总额(元)</div>
              <div>渠道手续费总额(元)</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finFeeAmount | toFenThousandsAndFloat}}</div>
              <div>{{row.thirdFeeAmount | toFenThousandsAndFloat}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="130" align="center">
            <template slot="header">
              <div>系统退回手续费总额(元)</div>
              <div>渠道退回手续费总额(元)</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finRefundFeeAmount | toFenThousandsAndFloat}}</div>
              <div>{{row.thirdRefundFeeAmount | toFenThousandsAndFloat}}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否确认" prop="confirmStatus" min-width="80" align="center">
            <template slot-scope="{row}">
              <span :class="{'text-red': row.confirmStatus === 0}">{{row.confirmStatusDesc}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属渠道" prop="channelTypeDesc" min-width="80" />
          <el-table-column label="操作" width="180">
            <template slot-scope="{row}">
              <div class="flex">
                <el-button
                  type="text" @click="handleDetail(row)" v-if="$has('FWS-DZZX-DZSK-XQ')"
                  v-track
                  trackCode='tradeListReceipt-2'
                >查看明细</el-button>
                <page-export-button
                  v-if="$has('FWS-DZZX-DZSK-XZ')"
                  buttonText="下载"
                  buttonType="text"
                  exportType="button"
                  exportServe="fin_counting_tradeReceiptReport"
                  :exportParams="{countingNo: row.countingNo}"
                  trackCode='tradeListReceipt-3'
                />
              </div>
              <div class="flex" v-if="row.confirmStatus === 0">
                <el-button
                  type="text" @click="handleOperate(1, row)" v-if="$has('FWS-DZZX-DZSK-CXHQ')"
                  v-track
                  trackCode='tradeListReceipt-4'
                >重新获取</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </base-box>
    <!-- 详情 -->
    <detail :visible.sync="isDetailShow" :countingNo="countingNo" />
    <!-- 操作 -->
    <jr-operate-dialog
      :visible.sync="isOperateShow"
      :text-config.sync="textConfig"
      :loading="opLoading"
      @submit="handleOperateSubmit"
    />
  </div>
</template>

<script>
import { getTradeReceiptList } from '@/api/counting';
import baseBox from '../components/base-box';
import tradeOperateMixins from './mixins/operate';
import detail from './components/receipt-detail';
import fileDownloadMixins from '@/mixins/file-download';

export default {
  name: 'TradeListReceipt',
  components: { baseBox, detail },
  data() {
    return {
      isDetailShow: false,
      loading: false,
      list: [],
      total: 0,
      countingNo: '',
      queryForm: {},
    };
  },
  mixins: [tradeOperateMixins, fileDownloadMixins],
  methods: {
    async getList(params = {}) {
      try {
        this.loading = true;
        const searchParams = { ...this.queryForm, ...params };
        this.queryForm = { ...searchParams };
        delete searchParams.timeType;
        const res = await getTradeReceiptList(searchParams);
        const { data, totalCount } = res;
        this.total = totalCount ?? 0;
        (data || []).forEach((it) => {
          it.exportLoading = false;
        });
        this.list = data || [];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.list = [];
        console.log(error);
      }
    },
    // 查看详情
    handleDetail(row) {
      this.countingNo = row.countingNo;
      this.isDetailShow = true;
    },
  },
};
</script>
